<nav class="navbar navbar-default" *ngIf="displayNavbar"></nav>
